import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import Loader from "../components/Loader";
import InnerBannerBreadcrumb from "../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../redux/services/apiSlice";
import PageLastUpdated from "../components/shared/PageLastUpdated";
import { extractDate } from "../Utils/utils";

function HtmlPageById({ apiPath, title, titleLink }) {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { id } = useParams();
  const { data: tableData = [], isLoading: tableIsLoading } =
    useGetProtectedApiDataQuery({
      url: apiPath,
      lang: languageType,
    });

  const tableObj = tableData.find((item) => item.nid === id);

  const lastUpdatedOn = useMemo(() => {
    return extractDate(tableObj);
  }, [tableObj]);

  console.log(lastUpdatedOn);
  if (tableIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="images/inner_aboutbann.jpg"
        title={title}
        titleLink={titleLink}
        levelTwo={true}
        levelThree={false}
        isActive={tableObj.title}
        titleTwo={tableObj.title}
      />
      <div className="inner-container">
        <div className="container">
          <section className="ourCompany">
            <div className="container">
              <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />

              <div className="row mb-5">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                  <div
                    dangerouslySetInnerHTML={{ __html: tableObj.body }}
                  ></div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default HtmlPageById;
